import { AMPLITUDE_FINANCIAL_DATE_OPTION } from 'hooks/amplitude';
import { SourceItem } from './financials-utils';

export type FinancialFilters = {
  datesRange: [Date, Date];
  dateType: string;
  searchTerm: string;
  program: string[];
  sourceName: string[];
  sourceType: string[];
  status: string[];
  depositAccount: string[];
  registration: string[];
  invoice: string[];
  paymentType: string[];
};

export type TransactionReport = {
  transactionDate: string;
  status: string;
  grossAmount: number;
  netAmount: number;
  fees: number;
  depositId: number;
  payoutId: number;
  merchantAccountDisplayName: string;
  depositDate: string;
  bankLast4: string;
  paymentLast4: string;
  paymentType: string;
  paymentDescription: string;
  orderId: number;
  orderType: string;
  amountPaid: number;
  amountTotal: number;
  amountBalance: number;
  organizationId: number;
  userId: number;
  userName: string;
  userEmail: string;
  referenceObjectType: string;
  sourceItems: SourceItem &
    {
      sourceId: number;
      sourceType: string;
      programSeason: string;
      sourceName: string;
      participantFirstName: string;
      participantLastName: string;
      type: string;
    }[];
};

export enum TRANSACTION_STATUS {
  SUCCEEDED = 'Succeeded',
  REFUNDED = 'Refunded',
  PARTIALLY_REFUNDED = 'Partially Refunded',
  FAILED = 'Failed',
}

export enum OUTSTANDING_STATUS {
  DUE = 'Due',
  PAST_DUE = 'Past Due',
  PENDING_CASH_PAYMENT = 'Pending Cash Payment',
  SCHEDULED = 'Scheduled',
}

export enum PAYMENT_TYPES {
  ACH = 'ACH',
  US_BANK_ACCOUNT = 'us_bank_account',
  CREDIT_CARD = 'credit card',
  CARD = 'card',
  CHECK = 'check',
  CASH = 'cash',
  OTHER = 'other',
  OFFLINE = 'offline',
}
export const PAYMENT_TYPES_FORMATTED = {
  [PAYMENT_TYPES.ACH]: 'ACH',
  [PAYMENT_TYPES.US_BANK_ACCOUNT]: 'ACH',
  [PAYMENT_TYPES.CREDIT_CARD]: 'CC',
  [PAYMENT_TYPES.CARD]: 'CC',
  [PAYMENT_TYPES.CHECK]: 'Check',
  [PAYMENT_TYPES.CASH]: 'Cash',
  [PAYMENT_TYPES.OTHER]: 'Other',
  [PAYMENT_TYPES.OFFLINE]: 'Offline',
};
export const FORMATTED_PAYMENT_TYPES = {
  CC: PAYMENT_TYPES.CARD,
  ACH: PAYMENT_TYPES.US_BANK_ACCOUNT,
  Cash: PAYMENT_TYPES.CASH,
  Check: PAYMENT_TYPES.CHECK,
  Offline: PAYMENT_TYPES.OFFLINE,
  Other: PAYMENT_TYPES.OTHER,
};

export const DATE_RANGE_ACTIONS_OPTIONS_FOR_AMPLITUDE = {
  today: AMPLITUDE_FINANCIAL_DATE_OPTION.TODAY,
  'last-7-days': AMPLITUDE_FINANCIAL_DATE_OPTION.LAST_7_DAYS,
  'last-14-days': AMPLITUDE_FINANCIAL_DATE_OPTION.LAST_14_DAYS,
  'last-30-days': AMPLITUDE_FINANCIAL_DATE_OPTION.LAST_30_DAYS,
  'month-to-date': AMPLITUDE_FINANCIAL_DATE_OPTION.LAST_30_DAYS,
  'year-to-date': AMPLITUDE_FINANCIAL_DATE_OPTION.LAST_30_DAYS,
  'custom-range': AMPLITUDE_FINANCIAL_DATE_OPTION.CUSTOM,
};

export type OutstandingReportRow = {
  amountBilled: string;
  amountDue: string;
  amountPaid: string;
  dueDate: string;
  id: string;
  members: string;
  programSeason: string;
  referenceObjectId: string;
  orderType: string;
  referenceObjectUrl: string;
  sourceName: string;
  status: string;
  sourceItems: OutstandingSourceItem[];
};

type OutstandingSourceItem = SourceItem & {
  teamId: string;
  teamName: string;
  type: string;
};

export type DepositSummary = {
  gross: number;
  net: number;
  fees: number;
};

export type OutstandingSummary = {
  scheduled: number;
  unpaidRegistration: number;
  overdueInvoices: number;
};

export type TransactionSummary = {
  gross: number;
  net: number;
  fees: number;
  refunds: number;
  failed: number;
};
